import React, { useEffect, useState } from 'react'
import client from '../../client/Client';
import HeaderBanner from '../ui/HeaderBanner';

interface Datacontent {
  BAIName: string,
  BAIBank: string,
  BAIBankBankagency: string,
  BAIBankIBAN: string,
  BAIBankNumber: string,
  BAIBankBICSwift: string,
  BAIBankTransferpurpose: string,
  RegistrationFormForTunisianAttendees: string,
  RegistrationForm: string,
  RegistrationFees: Array<{
    TypeofRegistration: string;
    IEEEMembers: string;
    IEEEsponsorMembers: string;
    NonMembers: string;
    _key: string;
  }>;
  AdditionalItems: Array<{
    TypeofItems: string;
    Price: string;
    _key: string;
  }>;
}

const Registration = () => {
  const [data, setData] = useState<Datacontent>()

  useEffect(() => {
    client.fetch('*[_type == "AccomodationANDRegistration"]') 
      .then((result) => {
        setData(result[0]);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [])
  console.log(data);
  // Check which buttons should be rendered
  const hasLocalAttendeesForm = data?.RegistrationFormForTunisianAttendees;
  const hasConferenceForm = data?.RegistrationForm;
  const showButtons = hasLocalAttendeesForm || hasConferenceForm;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title='Registration' />
      
      <div className="text-left space-y-8 pt-12">
        {/* Improved Header Section */}
        <div className="bg-blue-50 border-l-4 border-blue-901 p-6 rounded-lg shadow-sm">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-2">
            Registration Instructions
          </h1>
          <p className="text-lg text-gray-700">
            All authors are kindly requested to complete the registration form.<br />
            A copy of the bank transfer receipt should be scanned and sent by e-mail jointly to:{' '}
            <a className='text-blue-901 hover:text-blue-800 font-medium underline' href='mailto:info@ssd-multiconf.org'>
              info@ssd-multiconf.org
            </a>
          </p>
        </div>

        {/* Improved Button Section - Conditionally Rendered */}
        {showButtons && (
          <div className={`${hasLocalAttendeesForm && hasConferenceForm ? 'grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl' : 'flex justify-center'} mx-auto`}>
            {hasLocalAttendeesForm && (
              <a 
                href={`${data.RegistrationFormForTunisianAttendees}`}
                target="_blank"
                rel="noopener noreferrer"
                className='bg-white border-2 border-blue-901 rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center block'
              >
                <span className='text-blue-901 group-hover:text-white font-semibold text-lg'>
                  Registration form for local attendees
                </span>
              </a>
            )}
            {hasConferenceForm && (
              <a 
                href={`${data.RegistrationForm}`}
                target="_blank"
                rel="noopener noreferrer"
                className='bg-white border-2 border-blue-901 rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center block'
              >
                <span className='text-blue-901 group-hover:text-white font-semibold text-lg'>
                  Registration form (Attendance conference)
                </span>
              </a>
            )}
          </div>
        )}

        {/* Registration Fees Table */}
        {data?.RegistrationFees && data.RegistrationFees.length > 0 && (
          <div className="space-y-8">
            <div>
              <h1 className="w-full text-center text-2xl font-semibold text-red-500 mb-6">
                Registration Fees
              </h1>

              <table className="rounded-t-lg w-full mx-auto bg-gray-200 text-gray-800">
                <thead>
                  <tr>
                    <th className="px-4 py-3 text-left border-b-2 border-gray-300 font-semibold">
                      Type of Registration
                    </th>
                    <th className="px-4 py-3 text-center border-b-2 border-gray-300 font-semibold">
                      IEEE Members
                    </th>
                    <th className="px-4 py-3 text-center border-b-2 border-gray-300 font-semibold">
                      IEEE Sponsor Members
                    </th>
                    <th className="px-4 py-3 text-center border-b-2 border-gray-300 font-semibold">
                      Non-Members
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.RegistrationFees.map((fee, index) => (
                    <tr key={fee._key}>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                        {fee.TypeofRegistration}
                      </td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200 text-center">
                        {fee.IEEEMembers}
                      </td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200 text-center">
                        {fee.IEEEsponsorMembers}
                      </td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200 text-center">
                        {fee.NonMembers}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Additional Items Table */}
        {data?.AdditionalItems && data.AdditionalItems.length > 0 && (
          <div className="space-y-8">
            <div>
              <h1 className="w-full text-center text-2xl font-semibold text-red-500 mb-6">
                Additional Items
              </h1>

              <table className="rounded-t-lg w-full mx-auto bg-gray-200 text-gray-800">
                <thead>
                  <tr >
                    <th className="px-4 py-3 text-left border-b-2 border-gray-300 font-semibold">
                      Type of Items
                    </th>
                    <th className="px-4 py-3 text-center border-b-2 border-gray-300 font-semibold">
                      Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.AdditionalItems.map((item, index) => (
                    <tr key={item._key}>
                      <td className="px-4 py-3 text-left bg-gray-100 border-b border-gray-200 font-medium">
                        {item.TypeofItems}
                      </td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200 text-center">
                        {item.Price}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Payment Instructions */}

        <div className="bg-blue-50 border-l-4 border-blue-901 p-6 rounded-lg shadow-sm">

          <p className="text-lg text-gray-700">
            Please transfer the conference fee according to early registration to the following bank account. 
            You can only be registered if you have paid your conference fee.
          </p>
        </div>

        {/* Bank Information - Updated to Match Accommodation Table Style */}
        {data && (
          <div className="space-y-8">
            <div>
              <h1 className="w-full text-center text-2xl font-semibold text-red-500 mb-6">
                Bank Information
              </h1>

              <table className="rounded-t-lg w-full mx-auto bg-gray-200 text-gray-800">
                <tbody>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      Name
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIName}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      Bank
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBank}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      Bank Agency
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBankBankagency}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      IBAN
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBankIBAN}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      Account Number
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBankNumber}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      BIC / Swift
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBankBICSwift}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">
                      Transfer Purpose
                    </td>
                    <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                      <span className="w-full grid justify-items-center">
                        {data.BAIBankTransferpurpose}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Footer Note */}
        <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Fee Reduction Available
          </h3>
          <p className="text-gray-700">
            Attendees from low-income countries may request a reduction in registration fees. <br />
            For more details, contact:{' '}
            <a className='text-blue-901 hover:text-blue-800 font-medium underline' href='mailto:info@ssd-multiconf.org'>
              info@ssd-multiconf.org
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Registration